export const isObjectEmpty = (object: object) => {
  return Object.keys(object).length === 0;
};
